import { LogEvent } from "./LogEvent";
import { LogEventNames } from "../interfaces/ITelemetryLogger";
import { ILogServiceEvent, ILogServiceResponse } from "../interfaces/ILogServiceEvent";
import { DurationMeasureType } from "../interfaces/ILogEvent";

export enum ServiceRequestKeys {
    Response1Successful = "Response1Successful",
    Response1 = "Response1",
    Response2Successful = "Response2Successful",
    Response2 = "Response2",
    Response3Successful = "Response3Successful",
    Response3 = "Response3",
    ResponseCount = "ResponseCount",
    DurationSeconds = "DurationSeconds"
};

/**
 * This class serves as the base class for tracking telemetry from calling into an external services
 * Any new service events should:
 * a) have an entry in LogEventNames to pass into the constructor (with a "Service" prefix)
 * b) add an entry to the list in LogEvents.ts in order to use it for logging purposes
 * 
 * The eventName (aka name of the telemetry table) will indicate the name of the service associated
 */
export class LogServiceEvent implements ILogServiceEvent {
    private responseCount = 0;
    private logEvent: LogEvent<ServiceRequestKeys>;

    constructor(eventName: LogEventNames) {
        this.logEvent = new LogEvent<ServiceRequestKeys>(eventName);
    }

    /**
     * Emits an event in the "EventState" key, indicating the start of a service request
     * It will also start a duration measure automatically
     */
    Start() {
        this.logEvent.Start();
        this.logEvent.BeginDurationMeasure(DurationMeasureType.Normal, ServiceRequestKeys.DurationSeconds);
        this.responseCount = 0;
    }


    /**
     * Adds a response success boolean and string message to be aggregated with the next event emission.
     * First two responses and corresponding success boolean are logged in separate columns - "Response1Successful", "Response1", "Response2Successful"and "Response2"
     * The latest response after that (which is just before the next aggregation) will be emitted in "Response3Successful" and "Response3"
     * The count of responses will be logged in "ResponseCount"
     * 
     * @param response Indicates an object that has details about the response to be logged
     */
    AddResponse(response: ILogServiceResponse) {
        this.responseCount++;
        this.logEvent.IncrementCount(ServiceRequestKeys.ResponseCount);
        switch(this.responseCount) {
            case 1:
                this.logEvent.AddData([{ key: ServiceRequestKeys.Response1Successful, value: response.isSuccessful }, { key: ServiceRequestKeys.Response1, value: response.message }]);
                break;
            case 2:
                this.logEvent.AddData([{ key: ServiceRequestKeys.Response2Successful, value: response.isSuccessful }, { key: ServiceRequestKeys.Response2, value: response.message }]);
                break;
            case 3:
            default:
                this.logEvent.AddData([{ key: ServiceRequestKeys.Response3Successful, value: response.isSuccessful }, { key: ServiceRequestKeys.Response3, value: response.message }]);
                break;
        }

        if (response.isFinalResponse) {
            this.logEvent.End();
            this.responseCount = 0;
        }
    }
};